import { Banner } from '@loadsmart/miranda-react'

type SpotQuoteListRefreshBannerProps = {
  onRefreshList: () => void
}

export function SpotQuoteListRefreshBanner({ onRefreshList }: SpotQuoteListRefreshBannerProps) {
  function handleRefresh() {
    onRefreshList()
  }

  return (
    <Banner variant="warning">
      <Banner.Title>Failed to get spot quotes. Please reload to try again.</Banner.Title>
      <Banner.Actions>
        <Banner.ActionPrimary onClick={handleRefresh}>Reload</Banner.ActionPrimary>
      </Banner.Actions>
    </Banner>
  )
}
